var _g, _path, _mask, _g2, _path2, _mask2, _path3, _path4, _path5, _path6, _rect, _rect2, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputerShell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 483,
    viewBox: "0 0 371 483",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_304_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 478C16 480.761 18.2386 483 21 483H351C353.761 483 356 480.761 356 478V423H16V478Z",
    fill: "#C0C0C0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 482.5H351C353.485 482.5 355.5 480.485 355.5 478V423.5H16.5V478C16.5 480.485 18.5147 482.5 21 482.5Z",
    stroke: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_304_5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 476C24 478.761 26.2386 481 29 481H343C345.761 481 348 478.761 348 476V423H24V476Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_304_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 476C24 478.761 26.2386 481 29 481H343C345.761 481 348 478.761 348 476V423H24V476Z",
    fill: "#D9D9D9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 481H348H24ZM348 422H24V424H348V422ZM24 423V481V423ZM348 481V423V481Z",
    fill: "black",
    mask: "url(#path-3-inside-1_304_5)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_304_5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 10C10.2386 10 8 12.2386 8 15V419C8 421.761 10.2386 424 13 424H359C361.761 424 364 421.761 364 419V15C364 12.2386 361.761 10 359 10H13ZM76 54C59.9837 54 47 66.9837 47 83V232C47 248.016 59.9837 261 76 261H297C313.016 261 326 248.016 326 232V83C326 66.9837 313.016 54 297 54H76Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 10C10.2386 10 8 12.2386 8 15V419C8 421.761 10.2386 424 13 424H359C361.761 424 364 421.761 364 419V15C364 12.2386 361.761 10 359 10H13ZM76 54C59.9837 54 47 66.9837 47 83V232C47 248.016 59.9837 261 76 261H297C313.016 261 326 248.016 326 232V83C326 66.9837 313.016 54 297 54H76Z",
    fill: "#C0C0C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15C9 12.7909 10.7909 11 13 11V9C9.68629 9 7 11.6863 7 15H9ZM9 419V15H7V419H9ZM13 423C10.7909 423 9 421.209 9 419H7C7 422.314 9.68629 425 13 425V423ZM359 423H13V425H359V423ZM363 419C363 421.209 361.209 423 359 423V425C362.314 425 365 422.314 365 419H363ZM363 15V419H365V15H363ZM359 11C361.209 11 363 12.7909 363 15H365C365 11.6863 362.314 9 359 9V11ZM13 11H359V9H13V11ZM48 83C48 67.536 60.536 55 76 55V53C59.4315 53 46 66.4315 46 83H48ZM48 232V83H46V232H48ZM76 260C60.536 260 48 247.464 48 232H46C46 248.569 59.4315 262 76 262V260ZM297 260H76V262H297V260ZM325 232C325 247.464 312.464 260 297 260V262C313.569 262 327 248.569 327 232H325ZM325 83V232H327V83H325ZM297 55C312.464 55 325 67.536 325 83H327C327 66.4315 313.569 53 297 53V55ZM76 55H297V53H76V55Z",
    fill: "black",
    fillOpacity: 0.8,
    mask: "url(#path-5-inside-2_304_5)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 17C18.2386 17 16 19.2386 16 22V418C16 420.761 18.2386 423 21 423H351C353.761 423 356 420.761 356 418V22C356 19.2386 353.761 17 351 17H21ZM76 54C59.9837 54 47 66.9837 47 83V232C47 248.016 59.9837 261 76 261H297C313.016 261 326 248.016 326 232V83C326 66.9837 313.016 54 297 54H76Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 42C37.2386 42 35 44.2386 35 47V266C35 268.761 37.2386 271 40 271H333C335.761 271 338 268.761 338 266V47C338 44.2386 335.761 42 333 42H40ZM76 54C59.9837 54 47 66.9837 47 83V232C47 248.016 59.9837 261 76 261H297C313.016 261 326 248.016 326 232V83C326 66.9837 313.016 54 297 54H76Z",
    fill: "#C0C0C0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 331,
    width: 148,
    height: 18,
    rx: 2,
    fill: "#C0C0C0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 334,
    width: 140,
    height: 13,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 455,
    r: 9,
    fill: "#C0C0C0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_304_5",
    x: 16,
    y: 423,
    width: 340,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_304_5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_304_5",
    x: 24,
    y: 423,
    width: 324,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_304_5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerShell);
export default __webpack_public_path__ + "static/media/Computer-Shell.451dcb751cdba4515c1efbb5a45e6864.svg";
export { ForwardRef as ReactComponent };